import { render, staticRenderFns } from "./AutoSpecifications.vue?vue&type=template&id=37daee04"
import script from "./AutoSpecifications.vue?vue&type=script&lang=ts"
export * from "./AutoSpecifications.vue?vue&type=script&lang=ts"
import style0 from "./AutoSpecifications.vue?vue&type=style&index=0&id=37daee04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports